/**
 * @generated SignedSource<<b3bbeaf0295b6ff6d6f1862778181ff9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchPeopleScreen_data$data = {
  readonly peopleTql?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly account_id: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PersonSearchResultCard">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "SearchPeopleScreen_data";
};
export type SearchPeopleScreen_data$key = {
  readonly " $data"?: SearchPeopleScreen_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchPeopleScreen_data">;
};

import SearchPeoplePaginationQuery_graphql from './SearchPeoplePaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "peopleTql"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isSearchPeopleScreen"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": SearchPeoplePaginationQuery_graphql
    }
  },
  "name": "SearchPeopleScreen_data",
  "selections": [
    {
      "condition": "isSearchPeopleScreen",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "peopleTql",
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "organisationId",
              "variableName": "organisationId"
            },
            {
              "kind": "Variable",
              "name": "q",
              "variableName": "query"
            }
          ],
          "concreteType": "CpusSearchUserConnection",
          "kind": "LinkedField",
          "name": "__SearchPeopleScreen_peopleTql_connection",
          "plural": false,
          "selections": [
            {
              "concreteType": "CpusSearchUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "CpusSearchUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "account_id"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PersonSearchResultCard"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            {
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "endCursor"
                },
                {
                  "kind": "ScalarField",
                  "name": "hasNextPage"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "8978a6f93de2e4c615d4209217fd4fcf";

export default node;
